export const information = {
  autoFilled: '自動生成されます',
  successRegister: '登録成功しました。',
  confirm: 'のデータを更新します。よろしいですか？',
};

export const error = {
  required: '必須入力です',
  exceeded: '最大桁数を超えています',
  failedRegister: '登録失敗しました。',
  duplicatedData: '既に登録済みのテナントIDです。テナント一覧から編集をおこなってください。',
  authError: 'No current user',
};
